var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element-wrapper',{attrs:{"element":_vm.element}},[_c('image',{attrs:{"slot":"actual-element","x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"href":_vm.href},slot:"actual-element"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35dbfdd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide-elements/ImageElement.vue
// module id = 238
// module chunks = 0 1